<template>
  <div class="student-details">
    <div class="tuolele-main-box sutdent-info flex-wrap">
      <div class="sutdent-avatar">
        <div class="avatar-box">
          <div class="avatar-img img-wrap">
            <img :src="studentInfo.avatar" alt>
          </div>
          <div class="status-icon center-self-x">
            {{ studentInfo.attendance_status_name }}
          </div>
        </div>
        <div class="student-name">{{ studentInfo.child_name }}</div>
        <div class="student-point">当前积分：{{ studentInfo.point }}</div>
      </div>
      <div class="student-form">
        <el-form
          :inline="true"
          :model="studentInfo"
          label-position="right"
          label-width="130px"
        >
          <el-form-item label="所属店铺：">
            <el-input v-model="studentInfo.shop_name" disabled />
          </el-form-item>
          <el-form-item label="姓名：">
            <el-input
              v-model="studentInfo.child_name"
              :disabled="isDisabled"
            />
          </el-form-item>
          <el-form-item label="性别：">
            <el-select v-model="studentInfo.sex" :disabled="isDisabled">
              <el-option label="男" value="1" />
              <el-option label="女" value="2" />
            </el-select>
          </el-form-item>
          <el-form-item label="生日：">
            <el-date-picker
              v-model="studentInfo.birthday"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              :disabled="isDisabled"
            />
          </el-form-item>
          <el-form-item label="就读小学：">
            <el-select v-model="studentInfo.school_id" filterable :disabled="isDisabled">
              <el-option
                v-for="item in schoolList"
                :key="item.school_id"
                :label="item.school_name"
                :value="item.school_id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="年级：">
            <el-select v-model="studentInfo.grade_id" :disabled="isDisabled">
              <el-option
                v-for="item in gradeList"
                :key="item.value"
                :label="item.text"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="班级：">
            <el-select v-model="studentInfo.class" :disabled="isDisabled">
              <el-option
                v-for="item in classroomList"
                :key="item.value"
                :label="item.text"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="家长姓名：">
            <el-input
              v-model="studentInfo.parent_name"
              :disabled="isDisabled"
            ></el-input>
          </el-form-item> -->
          <el-form-item label="家长手机号：">
            <MobileHidden :params="{sub_id: studentInfo.sub_id }" :encrypt="studentInfo.mobile" />
          </el-form-item>

          <el-form-item label="周中扣费">

            <p>{{ studentInfo.timer_midweek }}</p>
          </el-form-item>
          <el-form-item label="周末扣费">

            <p>{{ studentInfo.timer_weekend }}</p>
          </el-form-item>
          <el-form-item label="学员备注信息：">
            <el-input
              v-model="studentInfo.remark"
              type="textarea"
              :rows="3"
              :disabled="isDisabled"
            />
          </el-form-item>
        </el-form>
      </div>
      <div class="student-form-btn">
        <el-button
          v-if="['46','75','70'].indexOf(userInfo.obligation_id)>-1"
          type="success"
          @click="fnUpdatePhone"
        >修改手机号</el-button>
        <el-button
          v-show="isDisabled"
          type="primary"
          @click="startUpdate"
        >编辑</el-button>
        <el-button
          v-show="!isDisabled"
          type="success"
          @click="postUpdate"
        >保存</el-button>
        <el-button
          v-if="studentInfo.attendance_status == 3"
          type="success"
          @click="resumeClass"
        >复课</el-button>
        <el-button
          v-show="!isDisabled"
          type="info"
          @click="stopUpdate"
        >取消</el-button>
      </div>
    </div>
    <div class="sutdent-child-frame tuolele-main-box">
      <div class="frame-title-list flex-wrap">
        <div
          v-for="(item, index) in frameList"
          :key="index"
          class="frame-title-item"
          :class="{ active: $route.path == item.link }"
        >
          <router-link
            :to="{
              path: item.link,
              query: { child_id: $route.query.child_id }
            }"
          >{{ item.title }}</router-link>
        </div>
      </div>
      <div class="frame-content">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>

import MobileHidden from '@/components/MobileHidden'

export default {
  name: 'StudentDetails',
  components: { MobileHidden },
  data() {
    return {
      studentInfo: {
        shop_name: '测试校区',
        child_name: '赵铁柱',
        sex: '1',
        birthday: '1999-11-11',
        school_id: '76',
        grade_id: '2',
        classroom: '2班',
        parent_name: '赵日天',
        mobile: '13804380438',
        remark: '我爸是赵日天'
      },
      updateInfo: {},
      schoolList: [],
      gradeList: [
        { value: '-2', text: '幼儿园小班' },
        { value: '-1', text: '幼儿园中班' },
        { value: '1', text: '幼儿园大班' },
        { value: '2', text: '一年级' },
        { value: '3', text: '二年级' },
        { value: '4', text: '三年级' },
        { value: '5', text: '四年级' },
        { value: '6', text: '五年级' },
        { value: '7', text: '六年级' },
        { value: '8', text: '初一' },
        { value: '9', text: '初二' },
        { value: '10', text: '初三' },
        { value: '11', text: '高一' },
        { value: '12', text: '高二' },
        { value: '13', text: '高三' }
      ],
      classroomList: [],
      frameList: [
        { title: '店铺就读信息', link: '/admin/users/studentDetails/shop' },
        { title: '订单信息', link: '/admin/users/studentDetails/order' },
        { title: '渠道销售信息', link: '/admin/users/studentDetails/channel' },
        { title: '积分变动详情', link: '/admin/users/studentDetails/point' },
        {
          title: '出勤&课耗详情',
          link: '/admin/users/studentDetails/attendance'
        },
        { title: '停课&复课详情', link: '/admin/users/studentDetails/classes' },
        {
          title: '历史小结详情',
          link: '/admin/users/studentDetails/historyReport'
        },
        {
          title: '回访记录详情',
          link: '/admin/users/studentDetails/returnVisit'
        }
      ],
      isDisabled: true,
      userInfo: localStorage.userInfo
        ? JSON.parse(localStorage.userInfo)
        : {}
    }
  },
  computed: {},
  watch: {},
  mounted() {
    const child_id = this.$route.query.child_id
    this.getInfoBasic(child_id)
    for (let index = 1; index <= 50; index++) {
      this.classroomList.push({
        value: `${index}班`,
        text: `${index}班`
      })
    }
  },
  methods: {
    async getSchoolList(shop_id) {
      const ret = await this.$http.getSchoolList({ shop_id })
      if (ret.code == 200) {
        this.schoolList = ret.data
      }
    },
    async getInfoBasic(child_id) {
      const ret = await this.$http.getInfoBasic({ child_id })
      if (ret.code == 200) {
        this.studentInfo = ret.data
        this.getSchoolList(this.studentInfo.shop_id)
      }
    },
    fnUpdatePhone() {
      this.$prompt(`家长手机: ${this.studentInfo.mobile}`, '修改手机号', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPlaceholder: '请输入手机号',
        inputPattern: /^1(1|3|4|5|6|7|8|9)\d{9}$/,
        inputErrorMessage: '手机号码不正确'
      }).then(({ value }) => {
        this.$http.changeBindingMobile({ childId: this.studentInfo.child_id, mobile: value }).then(res => {
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: '修改手机号成功'
            })
            this.getInfoBasic(this.studentInfo.child_id)
          }
        })
      }).catch(() => {

      })
    },

    resumeClass() {
      this.$confirm('是否复课？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.HJResumeClasses({ childId: this.studentInfo.child_id }).then(res => {
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: '复课成功'
            })
          }
        })
      }).catch(() => {

      })
    },
    startUpdate() {
      const updateInfo = JSON.stringify(this.studentInfo)
      this.updateInfo = JSON.parse(updateInfo)
      this.isDisabled = false
    },
    stopUpdate() {
      const studentInfo = JSON.stringify(this.updateInfo)
      this.studentInfo = JSON.parse(studentInfo)
      this.isDisabled = true
    },
    async postUpdate() {
      if (this.studentInfo.school_id != '0') {
        this.studentInfo.school_name = this.schoolList.filter(e => {
          return e.school_id == this.studentInfo.school_id
        })[0].school_name
      }

      if (this.studentInfo.grade_id == 0) {
        this.$message({
          type: 'error',
          message: '请选择年级'
        })
        return
      }
      console.log('-----1------')
      console.log(this.studentInfo.grade_id)
      console.log(this.gradeList)
      this.studentInfo.grade_name = this.gradeList.filter(e => {
        return e.value == this.studentInfo.grade_id
      })[0].text
      console.log('-----2------')
      this.studentInfo.child_id = this.$route.query.child_id
      const ret = await this.$http.improveBasic(this.studentInfo)
      if (ret.code == 200) {
        this.getInfoBasic(this.$route.query.child_id)
        this.isDisabled = true
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.student-details {
  .sutdent-info {
    text-align: center;
    .sutdent-avatar {
      font-size: 16px;
      color: $color_black;
      padding-right: 50px;
      .avatar-box {
        position: relative;
        width: 80px;
        margin: 0 auto 12px;
        .avatar-img {
          height: 80px;
          border-radius: 50%;
          background-color: $color_normal;
          overflow: hidden;
        }
        .status-icon {
          width: 60px;
          height: 20px;
          background-color: #ffc22f;
          border-radius: 4px;
          text-align: center;
          line-height: 20px;
          font-size: 14px;
          color: #fff;
          bottom: 0;
        }
      }
      .student-name {
        margin-bottom: 10px;
      }
    }
    .student-form {
      flex: 1;
      .el-form {
        display: flex;
        flex-wrap: wrap;
        .el-form-item {
          margin-bottom: 5px;
          ::v-deep .el-form-item__label {
            margin-right: 0;
            padding-right: 0;
          }
        }
        .el-input {
          width: 250px;
          ::v-deep .el-input__icon {
            color: $color_black;
          }
          &.is-disabled {
            ::v-deep .el-input__inner {
              background-color: #fff;
              border-color: transparent;
              color: $color_black;
              cursor: auto;
            }
          }
        }
        .el-textarea {
          width: 520px;
          ::v-deep textarea {
            resize: none;
          }
          &.is-disabled {
            ::v-deep .el-textarea__inner {
              background-color: #fff;
              border-color: transparent;
              color: $color_black;
              cursor: auto;
            }
          }
        }
        .el-select {
          width: 250px;
          ::v-deep .el-input {
            &.is-disabled {
              .el-input__inner {
                background-color: #fff;
                border-color: transparent;
                color: $color_black;
                cursor: auto;
              }
              .el-input__suffix {
                display: none;
              }
            }
          }
        }
      }
    }
    .student-form-btn {
      flex-direction: column;
      .el-button {
        width: 90px;
        height: 40px;
        margin: 0 0 20px;
        display: block;
      }
    }
  }
  .sutdent-child-frame {
    .frame-title-list {
      flex-wrap: nowrap;
      justify-content: space-between;
      border-bottom: 1px solid #f5f5f5;
      padding-bottom: 40px;
      .frame-title-item {
        font-size: 14px;
        a {
          color: $color_normal;
        }
        &.active a {
          color: $color_black;
        }
      }
    }
  }
}
</style>
